import React, { useEffect, useState } from 'react';
import { getIdentifiedPlatformClientId } from '@hmhco/login-config';
import logErrorWithContext from '@hmhco/client-monitoring/src/context/logErrorWithContext';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useLoginOptions } from '../../hooks/useLoginOptions';
import { LOCAL_STORAGE_ORG_REF_ID_KEY } from '../../constants/storageConstants';

export const LoginOptions = ({ platform }) => {
  const { getLoginOptions } = useLoginOptions();
  const [loginOptions, setLoginOptions] = useState([]);

  const orgRefId = localStorage.getItem(LOCAL_STORAGE_ORG_REF_ID_KEY);

  useEffect(() => {
    if (orgRefId) {
      getLoginOptions(getIdentifiedPlatformClientId(), orgRefId)
        .then(options => {
          if (Array.isArray(options) && options.length > 1) {
            setLoginOptions([...options.slice(1), options[0]]);
          }
        })
        .catch(error => {
          logErrorWithContext('Login options error', error);
        });
    }
  }, [orgRefId]);

  return (
    <Stack sx={{ width: '100%' }}>
      {loginOptions.length > 0 && (
        <Typography>
          <FormattedMessage
            id="loggedOut.ssoDescription"
            values={{ platform }}
          />
        </Typography>
      )}
      {loginOptions.map(option => (
        <Button
          size="medium"
          variant={
            option.type === 'USERNAME_PASSWORD' ? 'contained' : 'outlined'
          }
          key={option.name}
          href={option.login_url}
        >
          {option.type === 'USERNAME_PASSWORD'
            ? 'Username and Password'
            : option.name}
        </Button>
      ))}
    </Stack>
  );
};

LoginOptions.propTypes = {
  platform: PropTypes.string.isRequired,
};
export default LoginOptions;
